import React from "react";
var __jsx = React.createElement;
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import useIsMobile from "@hooks/useIsMobile";
var responsive = {
  all: {
    breakpoint: {
      max: 4000,
      min: 0
    },
    items: 1
  }
};
var CustomDot = function CustomDot(_ref) {
  var onClick = _ref.onClick,
    active = _ref.active;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    "aria-label": "Go to slide",
    style: {
      border: "none",
      background: active ? "#0D0DB5" : "#C4CDD6",
      width: isMobile ? active ? "16px" : "8px" : active ? "45px" : "22px",
      height: isMobile ? "4px" : "8px",
      borderRadius: "4px",
      transition: "all 0.3s",
      outline: "none",
      margin: "0 3px",
      cursor: "pointer",
      padding: 0
    }
  });
};
var OilImageGallery = function OilImageGallery(_ref2) {
  var gallery = _ref2.gallery,
    title = _ref2.title;
  var images = gallery.content;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement("div", {
    className: "relative w-full bg-[#F9FAFD] border border-solid border-[#E6E9EF] rounded-lg md:rounded-2xl p-4"
  }, gallery.logo && /*#__PURE__*/React.createElement("div", {
    className: "md:hidden absolute top-3 z-20 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: gallery.logo,
    alt: gallery.title,
    className: "h-9 w-auto object-contain rounded-sm shadow-sm",
    loading: "eager"
  }), isMobile && /*#__PURE__*/React.createElement("h1", {
    className: "text-xl font-semibold text-[#1B2035] truncate ps-2"
  }, title), " ")), gallery.logo && /*#__PURE__*/React.createElement("div", {
    className: "box-border hidden md:flex items-center justify-center absolute top-4 start-4 z-20 h-[52px] w-[52px] min-w-[52px] bg-white border border-solid border-[#E6E9EF] rounded-lg shadow-sm overflow-hidden"
  }, /*#__PURE__*/React.createElement("img", {
    src: gallery.logo,
    alt: gallery.title,
    loading: "eager",
    className: "w-full h-full object-contain"
  })), /*#__PURE__*/React.createElement("div", {
    className: "md:hidden h-10"
  }), /*#__PURE__*/React.createElement("div", {
    className: "relative px-10 md:px-24 pt-2 md:pt-10 md:mx-auto max-w-[665px]"
  }, /*#__PURE__*/React.createElement("style", null, "\n          .oil-gallery-carousel .react-multi-carousel-dot-list {\n            position: static !important;\n            margin-top: 12px;\n            display: flex !important;\n            justify-content: center;px-4 flex flex-col gap-3 md:px-6 md:max-w-[1200px] md:mx-auto\n            align-items: center;\n            bottom: auto !important;\n          }\n        "), /*#__PURE__*/React.createElement(Carousel, {
    responsive: responsive,
    ssr: true,
    deviceType: "all",
    arrows: false,
    infinite: images.length > 1,
    showDots: images.length > 1,
    renderDotsOutside: true,
    customDot: /*#__PURE__*/React.createElement(CustomDot, null),
    containerClass: "oil-gallery-carousel"
  }, images.map(function (src, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "w-full aspect-[16/9] md:aspect-[16/10] rounded-2xl overflow-hidden mb-6 md:mb-8"
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: "".concat(title, " ").concat(i + 1),
      className: "w-full h-full object-contain",
      loading: i === 0 ? "eager" : "lazy"
    }));
  }))));
};
export default OilImageGallery;